const initialState = {
  members: null,
  member: null,
};

const coreTeamReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_CORE_TEAM_MEMBERS":
      return { ...state, members: action.data };
    case "GET_CORE_TEAM_MEMBER_BY_ID":
      return { ...state, member: action.data };
    case "CREATE_CORE_TEAM_MEMBER":
    case "UPDATE_CORE_TEAM_MEMBER":
    case "DELETE_CORE_TEAM_MEMBER":
      return { ...state };
    default:
      return state;
  }
};

export default coreTeamReducer;
